import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { updateConnectorStatusLocationDetail } from './../redux/actions/locations'
import { config } from '../config'

export function useConnectorStatusPeriodicUpdate(locationId: string) {
    const dispatch = useDispatch()
    // Použijeme useRef, aby sme udržali referenciu na socket špecifickú pre tento hook
    const socketRef = useRef<WebSocket | null>(null)

    useEffect(() => {
        if (!locationId) return

        // 1. Ak už nejaký socket beží, zatvoríme ho
        if (socketRef.current) {
            socketRef.current.close()
        }

        // 2. Otvoríme nové spojenie
        const ws = new WebSocket(
            `${config.websocket}/ocpp/client_charging_connector_status${locationId}`,
            ['ocpp1.6']
        )
        socketRef.current = ws

        ws.onmessage = (event) => {
            const connectorInfoChanged = JSON.parse(event.data)
            console.log("WS Detail:", connectorInfoChanged)
            
            if (connectorInfoChanged.ChargingConnectorId) {
                // dispatch(updateChargingSessionLocationDetail(connectorInfoChanged))
            } else {
                dispatch(updateConnectorStatusLocationDetail(connectorInfoChanged))
            }
        }

        // 3. CLEAN-UP: Keď sa zmení ID alebo odídeš z komponentu, socket sa automaticky zavrie
        return () => {
            if (ws) {
                ws.close()
                socketRef.current = null
            }
        }
    }, [dispatch, locationId])
}